import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  LOGIN_ACTION_TYPE,
  headers,
  changePasswordUrl,
  CHANGE_PASSWORD_ACTION_TYPE,
  FORGET_PASSWORD_ACTION_TYPE,
  forgetPasswordUrl,
  loginUrl,
  SIGNUP_ACTION_TYPE,
  signUpUrl,
  verifyOtpUrl,
  VERIFY_OTP_ACTION_TYPE,
  LOGIN_URL,
} from "../../utils/constants";

export const login_action = (Email, password) => async (dispatch) => {
  try {
    const mapdata = {
      Email: Email,
      Password: password,
    };

    const res = await axiosPost(loginUrl, mapdata);
    if (res["error"] != 1) {
      sessionStorage.setItem("AwardsUserLoginData", JSON.stringify(res["data"]));
      sessionStorage.setItem(
        "loginAccesslist",
        JSON.stringify(res["data"]["loginAccesslist"])
      );
      sessionStorage.setItem("user_id", res["data"]["user_id"]);
      sessionStorage.setItem("email_address", res["data"]["email_address"]);
      sessionStorage.setItem("user_name", res["data"]["user_name"]);
      sessionStorage.setItem("role_id", res["data"]["role_id"]);
      sessionStorage.setItem("jury_id", res["data"]["jury_id"]);
      sessionStorage.setItem("accessToken", res["data"]["accessToken"]);
      sessionStorage.setItem("refreshToken", res["data"]["refreshToken"]);
    }

    dispatch({
      type: LOGIN_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const changePassword_action =
  (isReset, otp_id, currentPassword, newPassword) => async (dispatch) => {
    try {
      const mapdata = {
        user_id:
          parseInt(sessionStorage.getItem("user_id")) != null
            ? parseInt(sessionStorage.getItem("user_id"))
            : null,
        user_name:
          sessionStorage.getItem("user_name") != null
            ? sessionStorage.getItem("user_name")
            : null,
        isReset: isReset == 1 ? 1 : 0,
        otp_id: otp_id != null ? otp_id : null,
        currentPassword:
          currentPassword != null ? currentPassword.toString().trim() : null,
        newPassword: newPassword.toString().trim(),
      };
      const res = await axiosPost(changePasswordUrl, mapdata, headers);
      dispatch({
        type: CHANGE_PASSWORD_ACTION_TYPE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const forgetPassword_action = (email) => async (dispatch) => {
  try {
    const mapdata = {
      email: email,
    };
    const res = await axiosPost(forgetPasswordUrl, mapdata, headers);
    dispatch({
      type: FORGET_PASSWORD_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
export const verifyOtp_action = (otp_id) => async (dispatch) => {
  try {
    const mapdata = {
      otp_id: otp_id,
    };
    const res = await axiosGet(verifyOtpUrl, mapdata, headers);
    dispatch({
      type: VERIFY_OTP_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const signUp_action =
  (name, userPhone, email, password) => async (dispatch) => {
    try {
      const mapdata = {
        Name: name,
        userPhone: userPhone,
        Email: email,
        Password: password
      };

      const res = await axiosPost(signUpUrl, mapdata, headers);
      if (res["error"] != 1) {
        sessionStorage.setItem("AwardsUserLoginData", JSON.stringify(res["data"]));
        sessionStorage.setItem(
          "loginAccesslist",
          JSON.stringify(res["data"]["loginAccesslist"])
        );
        sessionStorage.setItem("user_id", res["data"]["user_id"]);
        sessionStorage.setItem("user_name", res["data"]["user_name"]);
        sessionStorage.setItem("role_id", res["data"]["role_id"]);
        sessionStorage.setItem("jury_id", res["data"]["jury_id"]);
        sessionStorage.setItem("accessToken", res["data"]["accessToken"]);
        sessionStorage.setItem("refreshToken", res["data"]["refreshToken"]);
      }
      dispatch({
        type: SIGNUP_ACTION_TYPE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const manageUserLoginSession_action = (
  user_id, role_id, login_type, login_by_admin_id, status
) => async (dispatch) => {
  try {
    const mapdata = { user_id, role_id, login_type, login_by_admin_id, status };
    const res = await axiosPost(loginUrl, mapdata);

    if (res["error"] !== 1) {
      const userData = res["data"];
      localStorage.setItem("tempLoginData", JSON.stringify(userData));
      userData["role_id"] = role_id;
      const dashboardUrl = `${LOGIN_URL}/${role_id == 2 ? 'juryDashboard' : (role_id == 1 || role_id == 3) ? 'adminDashboard' : role_id == 4 ? 'applicantDashboard' : ''}`;
      window.open(dashboardUrl, "_blank");

      dispatch({
        type: LOGIN_ACTION_TYPE,
        payload: res,
      });
      setTimeout(() => {
        localStorage.removeItem("tempLoginData");
      }, 5000);
    }

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
